import { render, staticRenderFns } from "./ModalViewExchangeDocument.vue?vue&type=template&id=318e21b1&"
import script from "./ModalViewExchangeDocument.vue?vue&type=script&lang=js&"
export * from "./ModalViewExchangeDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports